import React from "react";
import PropTypes from "prop-types";
import styles from "./DividerSectionElement.module.css";

/**
 * View component. Displays a divider for a feed item section.
 */
export function DividerSectionElement({ dividerColor }) {
  return (
    <div style={{ backgroundColor: dividerColor }} className={styles.divider} />
  );
}

DividerSectionElement.propTypes = {
  /**
   * The current color of the divider.
   */
  dividerColor: PropTypes.string,
};
